"use client";
import { Input } from "@/components/ui/input"
import {cn} from "@/lib/utils";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {useState} from "react";
import {FaEye, FaEyeSlash} from "react-icons/fa";

export function CWFInput({ control, name, className, label, placeholder,withIcon,showPass,setShowPass, ...props}) {

    return (
        <FormField
            control={control}
            name={name}
            render={({field}) => (
                <FormItem className={cn("grid w-full items-center h-max gap-1.5 space-y-0", className)}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <FormControl>
                        {withIcon
                            ?
                            <div className={"relative w-full"}>
                                <Input
                                    placeholder={placeholder ?? label ?? undefined}
                                    {...props}
                                    className={"input-ios"}
                                    value={field.value ?? ""}
                                    onChange={field.onChange}
                                />
                                <p className={"absolute top-1/2 -translate-y-1/2 right-1 cursor-pointer"}
                                    onClick={e =>{
                                        e.preventDefault();
                                        setShowPass(!showPass);
                                    }}
                                >
                                    {showPass ?
                                        <FaEyeSlash size={20} className={"text-primary"}/>
                                        :
                                        <FaEye size={20} className={"text-primary"}/>
                                    }
                                </p>
                            </div>

                            :
                            <Input
                                placeholder={placeholder ?? label ?? undefined}
                                {...props}
                                className={"input-ios"}
                                value={field.value ?? ""}
                                onChange={field.onChange}
                            />
                        }

                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />

    )
}
